import * as _ from "lodash";
import { takeUntil } from "rxjs/operators";
import { Component, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthenticationInfoService } from "@app/core/guards/authentication-info.service";
import { ImportMissingInvoiceNumberModel } from "@app/core/models/imports/import-missing-invoice-number.model";
import { ImportService } from "@app/core/services/import.service";
import { ModalComponent } from "@app/shared/components/modal/modal.component";
import { ModalHelper } from "@app/shared/models/modal-helper.model";
import { AnalysisMissingInvoiceNumberActionService } from "../analysis-missing-invoice-number-actions.service";
import { FileDownloadService } from "@app/core/services/filedownload.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-analysis-missing-invoice-number-detail',
    templateUrl: './analysis-missing-invoice-number-detail.component.html',
    styleUrls: ['./analysis-missing-invoice-number-detail.component.scss']
})
export class AnalysisMissingInvoiceNumberDetailComponent extends AnalysisMissingInvoiceNumberActionService implements OnDestroy {

    importMissingInvoiceNumberDocument: ImportMissingInvoiceNumberModel;
    showViewButton: boolean = false;
    showInjectButton: boolean = false;
    comment: string;

    constructor(
        public dialog: MatDialog,
        protected authenticationInfoService: AuthenticationInfoService,
        protected importService: ImportService,
        private dialogRef: MatDialogRef<AnalysisMissingInvoiceNumberDetailComponent>,
        private fileDownloadService: FileDownloadService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) data) {
        super(importService, authenticationInfoService, dialog);
        this.importMissingInvoiceNumberDocument = data.ImportMissingInvoiceNumberDocument;
        this.comment = this.importMissingInvoiceNumberDocument.Comment;
        this.showViewButton = data.ShowViewButton;
        this.showInjectButton = _.isNil(this.importMissingInvoiceNumberDocument.InjectedInvoiceId);
    }

    onSaveComment = () => {
        const isAlreadyPickedBySomeoneElse = this.IsPicked && !this.IsPickedByMe;
        if (isAlreadyPickedBySomeoneElse) {
            const confimModal = new ModalHelper().getConfirmationConfig(`Attention, ce document est affecté à quelqu'un d'autre. Voulez-vous quand même procéder ?`);
            const dialogRef = this.dialog.open(ModalComponent, confimModal);
            dialogRef.afterClosed()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((isSuccess: boolean) => {
                    if (isSuccess) {
                        this.saveComment();
                    }
                });
            return;
        }
        this.saveComment();
    }

    onPdfViewer = () => {
        window.open(`/analysis/missing-invoice-numbers/detail-pdf/${this.importMissingInvoiceNumberDocument.Id}`, '_blank');
        this.close(false);
    }

    saveComment = () => {
        this.importService.updateMissingInvoiceNumberDocument(this.importMissingInvoiceNumberDocument.Id, this.comment)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.importMissingInvoiceNumberDocument.Comment = this.comment;
                this.markDocumentAsPicked();
                this.close(true);
            }, _ => {
                this.close(false);
            });
    }

    close(isSuccess: boolean) {
        this.dialogRef.close(isSuccess);
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
    }

    onDownload = () => {
        this.importService.getMissingInvoiceNumberDocumentContent(this.importMissingInvoiceNumberDocument.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((blobData: Blob) => {
                this.fileDownloadService.downloadBlob(blobData, this.importMissingInvoiceNumberDocument.PdfFileName, "application/pdf");
            }, (_) => {
                const modalErreurConfig = new ModalHelper().getAlertConfig(`Une erreur est survenue lors du téléchargement.`);
                this.dialog.open(ModalComponent, modalErreurConfig);
            });
    }

    onInject = () => {
        this.close(true);
        this.router.navigate(['invoices/inject', this.importMissingInvoiceNumberDocument.Id]);
    }

    markDocumentAsPicked() {
        super.markDocumentAsPicked();
        this.close(true);
    }

    markDocumentAsUnPicked() {
        super.markDocumentAsUnPicked();
        this.close(true);
    }
}